import React from "react";
import { Container, ForgotPasswordWrapper } from "./styles";
import { Title, FormContainer } from "../shared/styles";
import LoginForm from "./form";
import Link from "components/link";
import routes from "utils/absoluteRoutes";
import { navigate } from "@reach/router";
import { message } from "antd";

const Login = () => {
  return (
    <Container>
      <Title>Login</Title>
      <FormContainer>
        <LoginForm />
      </FormContainer>
      {/* <ForgotPasswordWrapper>
        <Link to={routes.auth.forgotPassword} variant="grey2">
          Forgot Password
        </Link>
      </ForgotPasswordWrapper> */}
      <Link
        onClick={(e) => {
          e.preventDefault();
          message.info('Please contact a Zlto for Business Program Partner to obtain a signup link')
        }}
        weight="bold"
        variant="zltoLightBlue"
      >
        Sign up
      </Link>
    </Container>
  );
};
export default Login;
